require('./brokerCorporatesOperationsView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const InformativeItem = require('components/commons/informativeItem/informativeItem');
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerFormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const BrokerMiFIDUSPersonModal = require('mifid/components/brokerMiFIDUSPersonModal/brokerMiFIDUSPersonModal');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const brokerRightsBuyActions = require('actions/brokerRightsBuy');
const brokerCorporatesOperationsActions = require('actions/brokerCorporatesOperations');
const BrokerRequestFinancialOperationChangeActions = require('actions/brokerRequestFinancialOperationChange');
const BrokerStocksSaleOrderActions = require('actions/brokerStocksSaleOrder');
const BrokerStocksPurchaseOrderActions = require('actions/brokerStocksPurchaseOrder');
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const BrokerCashChargeActions = require('actions/brokerCashCharge');
const BrokerRightsCashExchangeActions = require('actions/brokerRightsCashExchange');
const BrokerRightsBuyActions = require('actions/brokerRightsBuy');
const BrokerRightsSellActions = require('actions/brokerRightsSell');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const { getSelectedMarketsExchangeAvailability } = require('actions/brokerExchangeAvailability');

// @constants
const {
    BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL,
    BROKER_CORPORATE_OPERATIONS_CANJE_PROCESS_TYPE,
    BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PROCESS_TYPE,
    BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PROCESS_TYPE,
    BROKER_CORPORATE_OPERATIONS_DERECHOS_PROCESS_TYPE,
    BROKER_CORPORATE_OPERATIONS_RIGHTS_SUBPROCESS_DESCRIPTION,
    BROKER_STOCKS_CONTRACT_DROPDOWN_CONTRACTS_MODIFIER,
    DATE_FORMAT_ES,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_RIGHTS_SELL_URL,
    MYPROFILE_BROKER_STOCKS_SALE_ORDER_WIZARD_URL,
    BROKER_CORPORATE_OPERATIONS_CHANGE_URL,
    BROKER_STOCKS_CONTRACT_URL,
    BROKER_CORPORATE_OPERATIONS_BUY_RIGHTS_URL,
    BROKER_CORPORATE_OPERATION_CASH_EXCHANGE_RIGHTS_URL,
    MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL
} = require('constants/index');

class BrokerCorporatesOperationsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expandedRow: -1,
            immOperationAffectedByMifid: null,
            operationAffectedByMifidOptions: {
                continuationUrl: '',
                feeNumbers: undefined,
                valueCode: undefined,
                eventCode: undefined
            }
        };

        this.handleRequestChange = this.handleRequestChange.bind(this);
        this.handleStocksSaleOrder = this.handleStocksSaleOrder.bind(this);
        this.handleStocksPurchaseOrder = this.handleStocksPurchaseOrder.bind(this);
        this.handleCashCharge = this.handleCashCharge.bind(this);
        this.handleExpanded = this.handleExpanded.bind(this);
        this.handleStocksContractChange = this.handleStocksContractChange.bind(this);
        this.buildStocksContractsDropdownOptions = this.buildStocksContractsDropdownOptions.bind(
            this
        );
        this.buildInformativeBlock = this.buildInformativeBlock.bind(this);
        this.buildTableHeader = this.buildTableHeader.bind(this);
        this.buildMoreInfo = this.buildMoreInfo.bind(this);
        this.buildRowActions = this.buildRowActions.bind(this);
        this.buildTableRows = this.buildTableRows.bind(this);
        this.buildResults = this.buildResults.bind(this);
        this.handleRightsBuyAction = this.handleRightsBuyAction.bind(this);
        this.handleRightsSellAction = this.handleRightsSellAction.bind(this);
        this.buildMifidModal = this.buildMifidModal.bind(this);
        this.handleContinueFromMifidModal = this.handleContinueFromMifidModal.bind(this);
        this.handleCancelFromMifidModal = this.handleCancelFromMifidModal.bind(this);
        // @hardcoded
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('corporatesOperations-corporatesOperations'),
                url: ''
            },
        ];
    }

    componentWillMount() {
        this.props.reset();
        this.props.getSelectedMarketsExchangeAvailability();
        this.props.fetchMyInvestments();
        this.props.checkPersonalInformationData();
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.immCorporatesOperations.get('stocksContracts') !==
            this.props.immCorporatesOperations.get('stocksContracts')
        ) {
            this.handleStocksContractChange(
                this.props.immCorporatesOperations.get('selectedContractValue')
            );
            this.props.requestSelectedContractOperations();
        }
    }

    handleRequestChange(immOperation) {
        const { immCorporatesOperations, startCorporativeOperationRequestChange } = this.props;
        const owner = immCorporatesOperations.getIn(['selectedContract', 'owner']);
        const contract = immCorporatesOperations.getIn(['selectedContract', 'contract']).toJS();
        const operation = immOperation.toJS();
        const associatedAccount = immCorporatesOperations
            .getIn(['selectedContract', 'associatedAccount'])
            .toJS();
        const cuenta = immCorporatesOperations.getIn(['selectedContract', 'cuenta']).toJS();
        const walletAccountType = immCorporatesOperations.getIn([
            'selectedContract',
            'walletAccountType'
        ]);

        const operations = immCorporatesOperations.getIn(['selectedContract', 'operations']);
        const corporateOperationIndex = operations.keyOf(immOperation);
        const isLoaded = true;

        startCorporativeOperationRequestChange(
            owner,
            contract,
            operation,
            associatedAccount,
            cuenta,
            walletAccountType,
            corporateOperationIndex,
            isLoaded
        );

        this.props.history.push(BROKER_CORPORATE_OPERATIONS_CHANGE_URL);
    }

    handleStocksSaleOrder(immOperation) {
        const { immCorporatesOperations, onStocksSaleOrder, setOperationIndex } = this.props;
        const immSelectedContract = immCorporatesOperations.get('selectedContract');
        const cuenta = immCorporatesOperations.getIn(['selectedContract', 'cuenta']).toJS();
        const operation = immOperation.toJS();
        const contract = immSelectedContract.get('contract').toJS();
        const owner = immSelectedContract.get('owner');
        const associatedAccount = immSelectedContract.get('associatedAccount').toJS();
        const walletAccountType = immSelectedContract.get('walletAccountType');
        const immOperations = immCorporatesOperations.getIn(['selectedContract', 'operations']);
        const operationIndex = immOperations.findIndex(immOp => immOp == immOperation);
        const operationValueCode = immOperation ? immOperation.get('linkId') : undefined;
        const operationEventCode = immOperation ? immOperation.get('eventCode') : undefined;
        const isLoaded = true;

        onStocksSaleOrder(cuenta, operation, contract, owner, associatedAccount, walletAccountType, isLoaded);
        setOperationIndex(operationIndex);

        this.updateOperationAffectedByMifid(
            immOperation,
            {
                continuationUrl: MYPROFILE_BROKER_STOCKS_SALE_ORDER_WIZARD_URL,
                valueCode: operationValueCode,
                eventCode: operationEventCode
            }
        );
    }

    handleStocksPurchaseOrder(immOperation) {
        const { immCorporatesOperations, onStocksPurchaseOrder } = this.props;
        const immSelectedContract = immCorporatesOperations.get('selectedContract');
        const cuenta = immCorporatesOperations.getIn(['selectedContract', 'cuenta']);
        const operation = immOperation.toJS();
        const contract = immSelectedContract.get('contract').toJS();
        const owner = immSelectedContract.get('owner');
        const associatedAccount = immSelectedContract.get('associatedAccount').toJS();
        const walletAccountType = immSelectedContract.get('walletAccountType');
        const isLoaded = true;

        onStocksPurchaseOrder(cuenta, operation, contract, owner, associatedAccount, walletAccountType, isLoaded);
        this.props.history.push(BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL);
    }

    updateOperationAffectedByMifid(immOperation, mifidOptions) {
        const noOperationAffectedByMifidRunning = this.state.immOperationAffectedByMifid == null;

        if (noOperationAffectedByMifidRunning) {
            this.setState({
                immOperationAffectedByMifid: immOperation,
                operationAffectedByMifidOptions: mifidOptions
            });
        }
    }

    handleSubscription(immOperation) {
        const operationValueCode = immOperation ? immOperation.get('linkId') : undefined;
        const operationEventCode = immOperation ? immOperation.get('eventCode') : undefined;

        const selectedContract = this.props.immCorporatesOperations.get('selectedContract').toJS();
        const selectedOperation = immOperation.toJS();

        this.props.onOperationSubscriptionClick(selectedContract, selectedOperation);

        this.updateOperationAffectedByMifid(
            immOperation,
            {
                continuationUrl: MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL,
                valueCode: operationValueCode,
                eventCode: operationEventCode
            }
        );
    }

    handleCashCharge(immOperation) {
        const { selectedRightsCashExchangeCorpOpIndexChanged } = this.props;
        this.updateRightsCorpOpIndex(immOperation, selectedRightsCashExchangeCorpOpIndexChanged);
        this.props.history.push(BROKER_CORPORATE_OPERATION_CASH_EXCHANGE_RIGHTS_URL);
    }

    updateRightsCorpOpIndex(immOperationSelected, callback) {
        const { immCorporatesOperations } = this.props;
        const immOperations = immCorporatesOperations.getIn(['selectedContract', 'operations']);

        if (immOperations && immOperationSelected) {
            const operationIndex = immOperations.findIndex(immOperation => immOperation == immOperationSelected);
            callback(operationIndex);
        }
    }

    handleRightsBuyAction(immOperation) {
        const { selectedRightsBuyCorpOpIndexChanged, rightsBuyReset } = this.props;

        rightsBuyReset();
        this.updateRightsCorpOpIndex(immOperation, selectedRightsBuyCorpOpIndexChanged);
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_BUY_RIGHTS_URL);
    }

    handleRightsSellAction(immOperation) {
        const { immCorporatesOperations, selectedRightsSellCorpOpIndexChanged } = this.props;
        const operations = immCorporatesOperations.getIn(['selectedContract', 'operations']);
        const corporateOperationIndex = operations.keyOf(immOperation);

        selectedRightsSellCorpOpIndexChanged(corporateOperationIndex);
        this.props.history.push(MYPROFILE_BROKER_RIGHTS_SELL_URL);
    }

    handleExpanded(whichRow) {
        const { immProfile } = this.props
        const browsingLanguage = immProfile.get('browsingLanguage')
        this.props.fetchAditionalInformation(whichRow, browsingLanguage)

        this.setState({
            expandedRow: this.state.expandedRow === whichRow ? -1 : whichRow
        });
    }

    handleStocksContractChange(value) {
        this.setState({ expandedRow: -1 });
        this.props.changeStocksContractValue(value);
        this.props.requestSelectedContractOperations();
    }

    buildStocksContractsDropdownOptions(stocksContracts) {
        const stocksContractsOptions = stocksContracts.map(entry => {
            const newEntry = entry.merge({
                value: entry.getIn(['contract', 'number'])
            });

            return newEntry;
        });

        return stocksContractsOptions.toJS();
    }

    buildInformativeBlock(selectedContract) {
        if (!selectedContract) {
            return;
        }

        const associatedAccountNumber = selectedContract.getIn(['associatedAccount', 'number']);

        if (associatedAccountNumber) {
            const owner = selectedContract.get('owner');
            const associatedAccountAmount = selectedContract.getIn(['associatedAccount', 'balance', 'amount']);
            const associatedAccountCurrency = selectedContract.getIn(['associatedAccount', 'balance', 'currency']);
            const intervention = formatText(`interventionTypes-${(selectedContract.get('intervention') || '').trim()}`);

            let salary = '';

            if (associatedAccountAmount && associatedAccountCurrency) {
                salary = (
                    <FormattedText
                        value="corporatesOperations-salary"
                        injectedStrings={[
                            formatAmount(associatedAccountAmount),
                            formatCurrency(associatedAccountCurrency)
                        ]}
                    />
                );
            }

            return (
                <div className="row no-gutter">
                    <div className="col-xs-4">
                        <InformativeItem
                            title={formatText('corporatesOperations-associatedAccount')}
                            primaryText={associatedAccountNumber}
                            secondaryText={salary}
                        />
                    </div>
                    <div className="col-xs-8">
                        <InformativeItem
                            title={formatText('corporatesOperations-titular')}
                            primaryText={owner}
                            secondaryText={formatText('corporatesOperations-titularInformativeItem', [intervention])}
                        />
                    </div>
                </div>
            );
        }
    }

    buildTableHeader() {
        return (
            <OKTableRow asHeader={true}>
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-dropdown"
                />
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-value"
                >
                    <FormattedText value="corporatesOperations-value" />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-operation"
                >
                    <FormattedText value="corporatesOperations-operation" />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-start-date"
                >
                    <FormattedText value="corporatesOperations-startDate" />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-end-date"
                >
                    <FormattedText value="corporatesOperations-limitDate" />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-corporates-operations-view__table-header-actions"
                />
            </OKTableRow>
        );
    }

    buildMoreInfo(key, operation) {
        const rowIsExpanded = this.state.expandedRow === key;
        const className = classNames({
            'broker-corporates-operations-view__more-info': !rowIsExpanded,
            'broker-corporates-operations-view__more-info-expanded': rowIsExpanded
        });

        const fetchingInfo = operation.get('fetchingAdditionalInformation');
        const fetchInfoError = operation.get('fetchedAdditionalInformationError');
        const startDate = DateHelper.buildFormattedDate(operation.get('startDate'), DATE_FORMAT_ES);
        const endDate = DateHelper.buildFormattedDate(operation.get('endDate'), DATE_FORMAT_ES);
        const closeDate = DateHelper.buildFormattedDate(operation.get('closeDate'), DATE_FORMAT_ES);
        const proporcionOf = operation.get('proportion');
        const additionalInformation = operation.get('additionalInformation');

        if (fetchingInfo || fetchInfoError) {
            const noInfoSection = fetchingInfo
                ? <LoadingSection />
                : (<EmptyState
                    primaryText={formatText('corporatesOperations-noInformationAvailable')}
                    iconType="noitems-wealth" />);

            return (
                <OKTableRow className={className}>
                    <OKTableCell colSpan={6}>
                        <OKTableRowDetails>
                            {noInfoSection}
                        </OKTableRowDetails>
                    </OKTableCell>
                </OKTableRow>
            );
        }

        let documentationSection;

        if (operation.get('subtipoProceso') === BROKER_CORPORATE_OPERATIONS_DERECHOS_PROCESS_TYPE
            || operation.get('subtipoProceso') === BROKER_CORPORATE_OPERATIONS_CANJE_PROCESS_TYPE
            || operation.get('subtipoProceso') === BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PROCESS_TYPE
            || operation.get('subtipoProceso') === BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PROCESS_TYPE) {
            const linkTriptico = operation.get('linkTriptico');
            const linkCNMV = operation.get('linkCNMV');
            let linkTripticoProc = linkTriptico.includes('/en/') ? linkTriptico.replace('/en/', '/') : linkTriptico;
            let linkCNMVProc = linkCNMV.includes('/en/') ? linkCNMV.replace('/en/', '/') : linkCNMV;
            if (getLanguage() === 'en') {
                linkTripticoProc = linkTripticoProc.replace('.pdf', 'EN.pdf');
                linkCNMVProc = linkCNMVProc.replace('.pdf', 'EN.pdf');
            }
            documentationSection = (
                <section>
                    <h4 className="broker-corporates-operations-view__more-info-expanded-title">
                        <FormattedText value="corporatesOperations-relatedDocumentation" />
                    </h4>
                    <a
                        className="broker-corporates-operations-view__more-info-expanded-pdf-button"
                        href={linkTripticoProc}
                        target="_blank"
                    >
                        <i className="icon-descargar" />
                        <FormattedText value="corporatesOperations-oficialCommunicationRegisteredInCNMV" />
                    </a>

                    <a
                        className="broker-corporates-operations-view__more-info-expanded-pdf-button"
                        href={linkCNMVProc}
                        target="_blank"
                    >
                        <i className="icon-descargar" />
                        <FormattedText value="corporatesOperations-informativeMessageCNMVLabel" />
                    </a>
                </section>
            );
        }

        return (
            <OKTableRow className={className}>
                <OKTableCell colSpan={2} />
                <OKTableCell colSpan={4}>
                    <OKTableRowDetails title={formatText('corporatesOperations-details')}>
                        <ul className="list-unstyled broker-corporates-operations-view__more-info-expanded-details broker-corporates-operations-view__section-border">
                            <li>
                                <FormattedText value="corporatesOperations-value" />:{' '}
                                <b>{operation.get('descriptionValue')}</b>
                            </li>
                            <li>
                                <FormattedText value="corporatesOperations-disbursement" />:{' '}
                                <b>{operation.get('payment')}</b>
                            </li>
                            <li>
                                <FormattedText value="corporatesOperations-term" />:{' '}
                                <b>
                                    <FormattedText
                                        value="corporatesOperations-termValue"
                                        injectedStrings={[startDate, endDate]}
                                        format="uppercase"
                                    />
                                </b>
                            </li>
                            <li>
                                <FormattedText
                                    value="corporatesOperations-termLimit"
                                    format="uppercase"
                                />: <b>{closeDate}</b>
                            </li>
                            <li>
                                <FormattedText
                                    value="corporatesOperations-emissionRatio"
                                    format="uppercase"
                                />: <b>{proporcionOf}</b>
                            </li>
                        </ul>

                        <div className="broker-corporates-operations-view__section-border">
                            <h4 className="broker-corporates-operations-view__more-info-expanded-title">
                                <FormattedText value="corporatesOperations-aditionalInformation" />
                            </h4>
                            <div className="broker-corporates-operations-view__more-info-expanded-additional-information">
                                <p>
                                    {additionalInformation}
                                </p>
                            </div>
                        </div>

                        {documentationSection}
                    </OKTableRowDetails>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildRowActions(immOperation) {
        let options = [];

        switch (immOperation.get('subtipoProceso')) {
            case BROKER_CORPORATE_OPERATIONS_CANJE_PROCESS_TYPE:
                options.push({
                    text: formatText('corporatesOperations-requestChange'),
                    handleClick: () => this.handleRequestChange(immOperation)
                });
                break;
            case BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PROCESS_TYPE:
                options.push({
                    text: formatText('corporatesOperations-stocksSaleOrder'),
                    handleClick: () => this.handleStocksSaleOrder(immOperation)
                });
                break;
            case BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PROCESS_TYPE:
                options.push({
                    text: formatText('corporatesOperations-purchaseOrder'),
                    handleClick: () => this.handleStocksPurchaseOrder(immOperation)
                });
                break;
            case BROKER_CORPORATE_OPERATIONS_DERECHOS_PROCESS_TYPE:
                if (
                    immOperation.get('descriptionProcess').trim() ===
                    BROKER_CORPORATE_OPERATIONS_RIGHTS_SUBPROCESS_DESCRIPTION
                ) {
                    options.push({
                        text: formatText('corporatesOperations-rightsBuy'),
                        handleClick: () => this.handleRightsBuyAction(immOperation)
                    });

                    options.push({
                        text: formatText('corporatesOperations-rightsSell'),
                        handleClick: () => this.handleRightsSellAction(immOperation)
                    });
                }

                options.push({
                    text: formatText('corporatesOperations-subscription'),
                    handleClick: () => this.handleSubscription(immOperation)
                });

                if (immOperation.get('isExisteEnDividendos', false)) {
                    options.push({
                        text: formatText('corporatesOperations-cashCharge'),
                        handleClick: () => this.handleCashCharge(immOperation)
                    });
                }

                break;
            default:
                break;
        }

        if (options.length > 0) {
            const targetElement = (
                <div className="account-more-options-button">
                    <OKButton
                        modifier="ghost"
                        rightIcon="icon-dropdown-abrir"
                        smallRightIcon={true}
                    >
                        <FormattedText value="corporatesOperations-operate" />
                    </OKButton>
                </div>
            );

            return <PopoverMenu target={targetElement} items={options} placement="bottomRight" />;
        }
    }

    buildTableRows() {
        const { immCorporatesOperations } = this.props;
        const contractOperations = immCorporatesOperations.getIn([
            'selectedContract',
            'operations'
        ]);

        return contractOperations.map((operation, key) => {
            const isExpanded = key === this.state.expandedRow;
            const dropDownIcon = classNames({
                'icon-accordion-cerrar': isExpanded,
                'icon-accordion-abrir': !isExpanded
            });

            const startDate = DateHelper.buildFormattedDate(operation.get('startDate'), DATE_FORMAT_ES);
            const closeDate = DateHelper.buildFormattedDate(operation.get('closeDate'), DATE_FORMAT_ES);
            const actionsButton = this.buildRowActions(operation);

            let descriptionProccess;
            switch (operation.get('subtipoProceso')) {
                case BROKER_CORPORATE_OPERATIONS_DERECHOS_PROCESS_TYPE:
                    descriptionProccess = formatText(
                        'corporatesOperations-descriptionProccessRights'
                    );
                    break;
                case BROKER_CORPORATE_OPERATIONS_CANJE_PROCESS_TYPE:
                    descriptionProccess = formatText(
                        'corporatesOperations-descriptionProccessExchange'
                    );
                    break;
                case BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PROCESS_TYPE:
                    descriptionProccess = formatText('corporatesOperations-descriptionProccessOPV');
                    break;
                case BROKER_CORPORATE_OPERATIONS_VENTA_ACCIONES_PROCESS_TYPE:
                    descriptionProccess = formatText('corporatesOperations-descriptionProccessOPA');
                    break;
                default:
                    descriptionProccess = operation.get('descriptionProcess', '').trim();
                    break;
            }

            return (
                <tbody key={key}>
                    <OKTableRow isExpanded={isExpanded}>
                        <OKTableCell>
                            <button
                                className="broker-corporates-operations-view__dropdown-button"
                                onClick={() => this.handleExpanded(key)}>
                                <i className={dropDownIcon} />
                            </button>
                        </OKTableCell>
                        <OKTableCell>
                            {operation.get('descriptionValue')}
                        </OKTableCell>
                        <OKTableCell withPaddingLeft>
                            <span className="broker-corporates-operations-view__description-process">
                                {descriptionProccess}
                            </span>
                        </OKTableCell>
                        <OKTableCell>
                            {startDate}
                        </OKTableCell>
                        <OKTableCell>
                            {closeDate}
                        </OKTableCell>
                        <OKTableCell>
                            {actionsButton}
                        </OKTableCell>
                    </OKTableRow>
                    {this.buildMoreInfo(key, operation)}
                </tbody>
            );
        });
    }

    buildResults() {
        const { immCorporatesOperations, immBrokerMyInvestments } = this.props;

        const errorText = formatText('corporatesOperations-noOperationsAvailable');
        const economicPoliticalRights = formatText(
            'corporatesOperations-onlyClearedOrdersAffectEconomicPoliticalRights'
        );

        const fetching =
            immCorporatesOperations.getIn(['selectedContract', 'loading']) ||
            immBrokerMyInvestments.get('isFetching');

        const fetched = immCorporatesOperations.getIn(['selectedContract', 'fetched']);
        const error = immCorporatesOperations.getIn(['selectedContract', 'error']);

        const immOperations = immCorporatesOperations.getIn(['selectedContract', 'operations']);
        const hasResults = immOperations && !immOperations.isEmpty();

        let result;

        if (fetching) {
            result = <LoadingSection />;
        } else if (error) {
            result = <EmptyState primaryText={errorText} iconType="noitems-wealth" />;
        } else if (fetched && hasResults) {
            result = (
                <table className="ok-table">
                    <thead>
                        {this.buildTableHeader()}
                    </thead>
                    {this.buildTableRows()}
                </table>
            );
        } else if (fetched && !hasResults) {
            result = <EmptyState primaryText={errorText} iconType="noitems-wealth" />;
        } else {
            return null;
        }

        return (
            <div>
                <div className="col-xs-12 grid-view--fix-cell-separation">
                    <OKSectionBox>
                        <h4 className="broker-corporates-operations-view__title">
                            <FormattedText value="corporatesOperations-corporativeOperationsSelectedContract" />
                        </h4>
                        {result}
                    </OKSectionBox>
                </div>
                <div className="col-xs-12 broker-corporates-operations-view__info">
                    {economicPoliticalRights}
                </div>
            </div>
        );
    }

    buildHelpCaption() {
        const helpLink = (
            <OKLink modifier="emphasize" to={BROKER_STOCKS_CONTRACT_URL}>
                <FormattedText value="corporatesOperations-helpCaptionButton" />
            </OKLink>
        );

        return (
            <p>
                <BrokerFormattedTextWithComponents
                    value="corporatesOperations-helpCaption"
                    injectedComponents={[helpLink]}
                />
            </p>
        );
    }

    handleContinueFromMifidModal() {
        const { immbrokerClientWarningModal, showClientWarningModal, history } = this.props;
        const { operationAffectedByMifidOptions } = this.state;
        const isClientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');

        if (isClientPersonalInfoUpdated) {
            history.push(operationAffectedByMifidOptions.continuationUrl);
        } else {
            showClientWarningModal(history);
        }

        window.modalInstance = this;
    }

    handleCancelFromMifidModal() {
        this.setState({
            immOperationAffectedByMifid: null,
            operationAffectedByMifidOptions: {}
        });
    }

    buildMifidModal() {
        const { immbrokerClientWarningModal } = this.props;
        const { immOperationAffectedByMifid, operationAffectedByMifidOptions } = this.state;

        const clientWarningFetched = immbrokerClientWarningModal.get('isFetched');

        let modal;

        if (clientWarningFetched && immOperationAffectedByMifid) {
            modal = (
                <BrokerMiFIDUSPersonModal
                    onContinueOperation={this.handleContinueFromMifidModal}
                    onCancel={this.handleCancelFromMifidModal}
                    isinId={immOperationAffectedByMifid.get('isin')}
                    marketId={immOperationAffectedByMifid.get('iso')}
                    {...operationAffectedByMifidOptions}
                />
            );
        }

        return modal;
    }

    render() {
        const { immCorporatesOperations, immVariables } = this.props;

        // @hardcoded TODO Verify the data of associatedAccountTel info
        // const associatedAccountTel = '0077 5544 3254 3222';

        const stocksContracts = immCorporatesOperations.get('stocksContracts');
        const stocksContractsOptions = this.buildStocksContractsDropdownOptions(stocksContracts);
        const stocksContractPlaceholder = formatText('corporatesOperations-contractsDropdownPlaceholder');
        const selectedContractValue = immCorporatesOperations.get('selectedContractValue');
        const selectedContract = immCorporatesOperations.get('selectedContract');
        const informativeBlock = this.buildInformativeBlock(selectedContract);
        const helpCaption = this.buildHelpCaption();

        /**
         * @TODO Check if results is still being used. If not, remove it. It was
         * an unresolved conflict.
         */
        const results = this.buildResults();

        const mifidModal = this.buildMifidModal();

        const onCancelFromMifidModal = this.handleCancelFromMifidModal;

        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));

        return (
            <div>
                <BrokerClientWarningModal
                    nextLocation={this.state.operationAffectedByMifidOptions.continuationUrl}
                    routerHookCallback={onCancelFromMifidModal}
                />
                {mifidModal}
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="corporatesOperations-corporatesOperations"
                                breadcrumbConfig={this.breadcrumb}
                                subtitleLeft={formatText('corporatesOperations-headerSubtitle')}>
                                <OKButton
                                    inverse={true}
                                    modifier="ghost"
                                    to={fees_url}
                                >
                                    <FormattedText value="corporatesOperations-commissions" />
                                </OKButton>
                            </BrokerTruncatedBreadcrumb>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <OKSectionBox title={formatText('corporatesOperations-consult')}>
                                    <StocksContractDropdown
                                        label="corporatesOperations-contract"
                                        options={stocksContractsOptions}
                                        selectedValue={selectedContractValue}
                                        onStockContractChange={this.handleStocksContractChange}
                                        modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_CONTRACTS_MODIFIER}
                                        placeholder={stocksContractPlaceholder}
                                        showAdditionalInfo={false}
                                    />
                                    {helpCaption}
                                    {informativeBlock}
                                </OKSectionBox>
                            </div>
                            {results}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerCorporatesOperationsView.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immbrokerClientWarningModal: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    changeStocksContractValue: PropTypes.func.isRequired,
    requestSelectedContractOperations: PropTypes.func.isRequired,
    onStocksSaleOrder: PropTypes.func.isRequired,
    setOperationIndex: PropTypes.func.isRequired,
    onStocksPurchaseOrder: PropTypes.func.isRequired,
    onOperationSubscriptionClick: PropTypes.func.isRequired,
    onCashCharge: PropTypes.func.isRequired,
    selectedRightsBuyCorpOpIndexChanged: PropTypes.func.isRequired,
    selectedRightsSellCorpOpIndexChanged: PropTypes.func.isRequired,
    selectedRightsCashExchangeCorpOpIndexChanged: PropTypes.func.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    fetchAditionalInformation: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    checkPersonalInformationData: PropTypes.func.isRequired,
    showClientWarningModal: PropTypes.func.isRequired,
    startCorporativeOperationRequestChange: PropTypes.func.isRequired,
    rightsBuyReset: PropTypes.func.isRequired,
    getSelectedMarketsExchangeAvailability: PropTypes.func.isRequired,
    immVariables: PropTypes.object.isRequired
};

module.exports.constructor = BrokerCorporatesOperationsView;
module.exports.BrokerCorporatesOperationsView = connect(
    state => ({
        immProfile: state.profile,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immVariables: state.globalVariables
    }),
    {
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        getSelectedMarketsExchangeAvailability: getSelectedMarketsExchangeAvailability,
        changeStocksContractValue: brokerCorporatesOperationsActions.changeStocksContractValue,
        requestSelectedContractOperations: brokerCorporatesOperationsActions.requestSelectedContractOperations,
        reset: brokerCorporatesOperationsActions.reset,
        rightsBuyReset: brokerRightsBuyActions.reset,
        onStocksSaleOrder: BrokerStocksSaleOrderActions.start,
        setOperationIndex: BrokerStocksSaleOrderActions.setOperationIndex,
        onStocksPurchaseOrder: BrokerStocksPurchaseOrderActions.start,
        onOperationSubscriptionClick: BrokerSubscriptionActions.setSubscriptionInfo,
        onCashCharge: BrokerCashChargeActions.start,
        selectedRightsBuyCorpOpIndexChanged:
            BrokerRightsBuyActions.selectedCorporateOperationIndexChanged,
        selectedRightsSellCorpOpIndexChanged:
            BrokerRightsSellActions.selectedCorporateOperationIndexChanged,
        selectedRightsCashExchangeCorpOpIndexChanged:
            BrokerRightsCashExchangeActions.setSelectedOperation,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.startFromCorporateOperation,
        fetchAditionalInformation: brokerCorporatesOperationsActions.fetchAditionalInformation,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        startCorporativeOperationRequestChange:
            BrokerRequestFinancialOperationChangeActions.startOperation
    }
)(withRouter(BrokerCorporatesOperationsView));
